<script setup lang="ts">
import type { ShowcaseContentResourceDto } from '@repo/api/web/models'

import UiPicture from '~/app/components/Image/UiPicture.vue'

// галерея материала (CMS MR 12): изображения из ContentItemResource,
// порядок задаёт бэкенд
const props = defineProps<{
  items: ShowcaseContentResourceDto[]
}>()
</script>

<template>
  <section v-if="props.items.length" class="mt-10">
    <h2 class="mb-4 text-xl font-semibold">
      Галерея
    </h2>
    <div class="grid grid-cols-2 gap-3 md:grid-cols-3">
      <UiPicture
        v-for="image in props.items"
        :key="image.resourceId"
        :src="image.resourceId"
        variant="imageFull"
        class="aspect-square w-full overflow-hidden rounded-xl"
        sizes="50vw md:240px"
        loading="lazy"
        :alt="image.displayName || ''"
      />
    </div>
  </section>
</template>
